module.exports = __webpack_public_path__ + "img/stock0.e88464da.png";